'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const CDN_URL = "//at.alicdn.com/t/font_3114948_h2a4tgipypo.js";
function createStyle() {
    const style = document.createElement('style');
    style.innerHTML = `.icon {
        width: 1em; height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
     }`;
    return style;
}
function createUrl() {
    const script = document.createElement('script');
    script.src = CDN_URL;
    return script;
}
const styleTag = createStyle();
const cdnUrlTag = createUrl();
let actives = 0;
function Icon({ type, size = 16, onClick = () => { } }) {
    React.useEffect(() => {
        if (actives === 0) {
            document.head.appendChild(styleTag);
            document.head.appendChild(cdnUrlTag);
        }
        actives++;
        return () => {
            actives--;
            if (actives === 0) {
                document.head.removeChild(styleTag);
                document.head.removeChild(cdnUrlTag);
            }
        };
    }, []);
    return (React__default["default"].createElement("span", { style: { fontSize: `${size}px` }, onClick: onClick },
        React__default["default"].createElement("svg", { className: "icon", "aria-hidden": "true" },
            React__default["default"].createElement("use", { xlinkHref: `#icon-${type}` }))));
}

exports.Icon = Icon;
